import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useFeatureUseRouteTracking } from '@hooks/useFeatureUseRouteTracking'
import { Box, AppBar, Toolbar, Typography, Chip, IconButton } from '@mui/material'
import { AdminPanelSettings as AdminIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import Header from './Header'
import AdminSidebar from './AdminSidebar'
import { DRAWER_WIDTH, ADMIN_BANNER_HEIGHT, HEADER_HEIGHT, headerOffsetCss } from './layoutConstants'
import { useAppShellDrawerState } from './useAppShellDrawer'
import { appMainContentSx } from './mainContentStyles'

const AdminLayout: React.FC = () => {
  const navigate = useNavigate()
  const { mobileOpen, toggleMobileDrawer, closeMobileDrawer, isTemporaryDrawer } =
    useAppShellDrawerState()

  useFeatureUseRouteTracking()

  const handleBackToApp = () => {
    navigate('/app')
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AdminSidebar mobileOpen={mobileOpen} onMobileClose={closeMobileDrawer} />
      <Box
        data-testid="app-main-column"
        data-shell-mode={isTemporaryDrawer ? 'temporary' : 'permanent'}
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: isTemporaryDrawer ? '100%' : `calc(100% - ${DRAWER_WIDTH}px)`,
        }}
      >
        <Header
          showMenuButton={isTemporaryDrawer}
          onMenuToggle={toggleMobileDrawer}
          menuOpen={mobileOpen}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            marginTop: headerOffsetCss,
          }}
        >
          <AppBar
            position="static"
            color="secondary"
            elevation={1}
            sx={{
              height: ADMIN_BANNER_HEIGHT,
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: 'warning.main',
            }}
          >
            <Toolbar variant="dense" sx={{ minHeight: ADMIN_BANNER_HEIGHT }}>
              <AdminIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="subtitle2" component="div" sx={{ flexGrow: 1 }}>
                Admin Panel
              </Typography>
              <Chip
                label="Admin Mode"
                size="small"
                color="warning"
                variant="outlined"
                sx={{ mr: 2 }}
              />
              <IconButton
                size="small"
                onClick={handleBackToApp}
                sx={{ color: 'inherit' }}
                title="Back to App"
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
            </Toolbar>
          </AppBar>

          <Box
            component="main"
            sx={{
              ...appMainContentSx,
              marginTop: 0,
              minHeight: `calc(100vh - ${HEADER_HEIGHT}px - ${ADMIN_BANNER_HEIGHT}px - env(safe-area-inset-top, 0px))`,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AdminLayout
